// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3kQm1","row":"ProcedureTreatmentSummary_row__3-GeZ"};